import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Environment } from "../../features/cms-manager/types/config";

interface CmsState {
  currentEnvironment: Environment;
  selectedConfigId: string | null;
}

const initialState: CmsState = {
  currentEnvironment: "DEV",
  selectedConfigId: null,
};

export const cmsSlice = createSlice({
  name: "cms",
  initialState,
  reducers: {
    setEnvironment: (state, action: PayloadAction<Environment>) => {
      state.currentEnvironment = action.payload;
    },
    setSelectedConfig: (state, action: PayloadAction<string | null>) => {
      state.selectedConfigId = action.payload;
    },
  },
});

export const { setEnvironment, setSelectedConfig } = cmsSlice.actions;
export default cmsSlice.reducer;
